









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

@Component({
  computed: {
    ...mapState('User', {
      user: 'adminUser',
      normalGroups: 'normalGroups',
    }),
    ...mapState('Authorization', {
      keys: 'keys',
    }),
  },
})
export default class UserProfilePrivilege extends Vue {
  user!: User;

  tmpUser: User = {
    group_ids: [],
    all_main_keys: [],
  };

  isLoading: string | boolean = false;

  normalGroups!: [];
  keys!: { id: number; groups: { id: number }[] }[];

  showKeyIds: number[] = [];

  filterGroupId: number | null = null;

  @Watch('user', { deep: true })
  watchUser(v) {
    if (v) {
      this.tmpUser = _.cloneDeep(v);
    }
  }

  @Watch('filterGroupId')
  watchFilterGroupId(v) {
    if (v) {
      const keys = this.keys.filter(
        (key) => !_.isEmpty(key.groups.find((group) => group.id === v))
      );

      this.showKeyIds = _.map(keys, 'id');
    } else {
      this.showKeyIds = _.map(this.keys, 'id');
    }
  }

  beforeMount() {
    this.showKeyIds = _.map(this.keys, 'id');
  }

  mounted() {
    if (this.user) {
      this.tmpUser = _.cloneDeep(this.user);
    }
  }

  updateGroup() {
    // add new group to the user
    let groupIds = _.difference(this.tmpUser.group_ids, this.user.group_ids);
    if (groupIds.length == 0) {
      // remove current group from user
      groupIds = _.difference(this.user.group_ids, this.tmpUser.group_ids);
    }

    const groupId = Number(groupIds.toString());
    this.isLoading = 'group_' + groupId;

    this.$store
      .dispatch('User/update', {
        id: this.tmpUser.id,
        payload: {
          group_ids: this.tmpUser.group_ids,
        },
      })
      .then(() => {
        this.$store
          .dispatch('User/fetch', {
            id: this.tmpUser.id,
          })
          .then(() => {
            this.isLoading = false;
          });
      });
  }

  updateKey() {
    let is_add = 1;
    // add new key to the user
    let keyIds = _.difference(
      this.tmpUser.all_main_keys,
      this.user.all_main_keys
    );
    if (keyIds.length == 0) {
      // remove current key from user
      keyIds = _.difference(
        this.user.all_main_keys,
        this.tmpUser.all_main_keys
      );
      is_add = 0;
    }

    const keyId = Number(keyIds.toString());
    this.isLoading = 'key_' + keyId;

    this.$store
      .dispatch('User/key', {
        id: this.tmpUser.id,
        payload: {
          key_id: keyId,
          is_add: is_add,
        },
      })
      .then(() => {
        this.$store
          .dispatch('User/fetch', {
            id: this.tmpUser.id,
          })
          .then(() => {
            this.isLoading = false;
          });
      });
  }
}
